import React, { useEffect, useState } from 'react';

import './users-list.scss';
import { useModal } from '@ampol/design-system';
import { useSelector } from 'react-redux';
import AccUserInfo from 'containers/account-user-info/account-user-info';
import PageHeader from 'components/layout/page-header/page-header';
import AddUserModal from 'features/users/modals/add-user-modal/add-user-modal';
import UserDetailModal from 'features/users/modals/user-detail-modal/user-detail-modal';
import Env from 'Env';
import isEmpty from 'utilities/isEmpty';
import { truncate } from 'utilities/strings';
import { trackCustomEvent } from 'utilities/app-insights';

/**
 * Describe component here
 * @param props
 */
const UsersList = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [showAddUserModal, setShowAddUserModal] = useState(false);

  const isAdminPortal = Env.isAdminPortal();

  const primaryActionButton = useSelector((state) => state.modalStore.primaryActionButton);
  const secondaryActionButton = useSelector((state) => state.modalStore.secondaryActionButton);

  const detailedUser = useSelector((state) => state.userStore.detailedUser);
  const adminDetailedUser = useSelector((state) => state.userStore.adminDetailedUser);

  const canReadWrite = useSelector((state) => state.userStore.canReadWriteUsers);

  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);

  useEffect(() => {
    if (selectedUser) {
      detailModal.open();
    }
  }, [selectedUser]);

  const handleClose = () => {
    trackCustomEvent('Close User Detail Modal', loggedInUser, assignedAccountNumber, 'User Detail Modal closed.');
    detailModal.close();
  };

  const getModalActions = () => [
    ...(primaryActionButton ? [primaryActionButton] : []),
    ...(secondaryActionButton ? [{ ...secondaryActionButton, onClick: secondaryActionButton.onClick || handleClose }] : []),
  ];

  const getTitle = () => {
    let name = 'Unknown';

    if ((detailedUser && !isEmpty(detailedUser)) || (adminDetailedUser && !isEmpty(adminDetailedUser))) {
      name = isAdminPortal ? `${adminDetailedUser.givenName} ${adminDetailedUser.familyName}` : `${detailedUser.givenName} ${detailedUser.familyName}`;
    } 

    if (selectedUser) {
      name = `${selectedUser.givenName} ${selectedUser.familyName}`;
    }
      
    return truncate(name, 30);
    
  };

  const detailModal = useModal({
    id: 'user-details',
    title: getTitle(),
    subtitle: 'User',
    content: <UserDetailModal 
      selectedUser={selectedUser}
      onClose={handleClose}
    />,
    variant: 'triple',
    color: 'blue',
    actions: getModalActions(),
    onClose: () => setSelectedUser(null),
    formId: primaryActionButton?.formId,
  });

  const handleUserSelected = (user) => {
    trackCustomEvent('Open User Detail Modal', loggedInUser, assignedAccountNumber, 'Clicked on the row of users list to view the user detail modal.');
    setSelectedUser(user);
  };

  const handleAddNewUser = () => {
    trackCustomEvent('Add New User Click', loggedInUser, assignedAccountNumber, 'Clicked Add New User button.');
    setShowAddUserModal(true);
  };

  return <div className={'users-list'}>
    <PageHeader
      title="Users"
      showButton={canReadWrite}
      buttonLabel="Add new user"
      onButtonClick={handleAddNewUser}
    />
    {showAddUserModal &&
      <AddUserModal
        onClose={() => setShowAddUserModal(false)}
      />
    }
    <AccUserInfo 
      onUserSelected={handleUserSelected}
    /> 
  </div>;
};

export default UsersList;
